export default "__VITE_ASSET__C0kDztF2__"